/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DmvsDtiDocsCloseInterruptPartialUpdateRequest = {} | null | undefined;
export type DmvsDtiDocsCloseInterruptPartialUpdateResponse = any;

export type DmvsDtiDocsCloseInterruptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dmvs_dti_docs/{id}/close_interrupt/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_close_interrupt_partial_update
 * tags:
 *   - dmvs_dti_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsDtiDocsCloseInterruptPartialUpdateOperation = ({
  id,
  ...rest
}: DmvsDtiDocsCloseInterruptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dmvs_dti_docs/${id}/close_interrupt/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dmvs_dti_docs/{id}/close_interrupt/' };
  };

/**
 * PATCH /dmx-server/dmvs_dti_docs/{id}/close_interrupt/
 *
 * ```yaml
 * operationId: dmvs_dti_docs_close_interrupt_partial_update
 * tags:
 *   - dmvs_dti_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsDtiDocsCloseInterruptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsDtiDocsCloseInterruptPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dmvsDtiDocsCloseInterruptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
